import merge from "lodash/merge";
import { StyleSheet } from "react-native";

export const withStyles = (Component, styles) => {
    
    return (props) => {

        const {
            style = {},
            textStyle = {},
            ...rest
        } = props;

        const {
            textStyle: stylesTextStyle,
            style: stylesStyle,
            ...stylesRest
        } = styles;
        
        const mergedRest = merge(stylesRest, rest);
        const _textStyles = StyleSheet.flatten([textStyle, stylesTextStyle]);
        const _style = StyleSheet.flatten([style, stylesStyle]);
        
        return <Component style={_style} textStyle={_textStyles} {...mergedRest} />;
    }
};